import { Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function BrokenLink() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        gap: 2,
        textAlign: 'center',
      }}
    >
      <Typography variant="h4" gutterBottom>
        Invalid Activation Link
      </Typography>
      <Typography variant="body1">
        The activation link you used is either expired or invalid.
      </Typography>
      <Typography variant="body1">
        Please contact your administrator for a new activation link.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/')} sx={{ mt: 2 }}>
        Go to Login Page
      </Button>
    </Box>
  );
}
